import { Link } from "react-router-dom";
import { categories } from "@/mocks/comics";

export default function CategoryShowcase() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="mb-10 md:mb-14">
          <p className="text-xs text-foreground-400 uppercase tracking-wider mb-2">
            分类浏览
          </p>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-black text-foreground-950 leading-tight"
            style={{ fontFamily: "var(--font-heading)" }}>
            探索你喜欢的<span className="text-primary-500">韩漫类型</span>
          </h2>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 md:gap-6">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 rounded-lg p-5 md:p-6 hover:bg-background-50 transition-colors duration-300"
            >
              <div className="w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-lg bg-background-100 group-hover:bg-primary-100/70 transition-colors duration-300 mb-4">
                <i className={`${cat.icon} text-xl text-foreground-700 group-hover:text-primary-500 transition-colors duration-300`}></i>
              </div>
              <h3 className="text-base md:text-lg font-bold text-foreground-900 mb-2 whitespace-nowrap">
                {cat.name}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                {cat.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}